import { randomInRange } from '~/bootcamp/Activities/utils/activities.utils'

/**
 * It generates a random numerator and denominator, and then validates the numerator against the
 * history
 * @param {number} minNumerator - The minimum value for the numerator.
 * @param {number} maxNumerator - The maximum value of the numerator.
 * @param {number} minDenominator - The minimum value for the denominator.
 * @param {number} maxDenominator - The maximum denominator that can be generated.
 * @param {number[]} history - an array of numbers that have already been used in the current activity.
 * @returns { numerator: number; denominator: number }
 */
export function generateDenominatorNumerator(
  minNumerator: number,
  maxNumerator: number,
  minDenominator: number,
  maxDenominator: number,
  history: number[],
): { numerator: number; denominator: number } {
  let numerator = randomInRange(minNumerator, maxNumerator + 1)
  numerator = validateNumberWithHistory(numerator, minNumerator, maxNumerator, history)
  const denominator = randomInRange(Math.max(numerator + 1, minDenominator), maxDenominator + 1)
  return { numerator, denominator }
}

function validateNumberWithHistory(currentValue: number, min: number, max: number, history: number[]): number {
  if (history.includes(currentValue)) {
    currentValue++
    if (currentValue > max) {
      currentValue = min
    }
    return validateNumberWithHistory(currentValue, min, max, history)
  }
  return currentValue
}

export function getRandomInt(min: number, max: number, excludeNums?: number[]): number {
  const excludes = new Set<number>(excludeNums || [])
  const values = Array.from(new Array(max - min + 1).keys())
    .map((i) => i + min)
    .filter((v) => !excludes.has(v))
  const randomIndex = Math.floor(Math.random() * values.length)
  return values[randomIndex]
}

export function getInt(min: number, max: number, excludeNum?: number[]): number {
  const excludes = new Set<number>(excludeNum || [])
  const values = Array.from(new Array(max - min + 1).keys())
    .map((i) => i + min)
    .filter((v) => !excludes.has(v))
  return values[0]
}
/**
 * It generates a random integer which is multiple of given multiplier
 * */
export function getRandomIntMultipleOf(min: number, max: number, multiplier: number, excludeNums?: number[]): number {
  const excludes = new Set<number>(excludeNums || [])
  const values = Array.from(new Array(max - min + 1).keys())
    .map((i) => i + min)
    .filter((v) => !(excludes.has(v) || v % multiplier !== 0))
  const randomIndex = Math.floor(Math.random() * values.length)
  return values[randomIndex]
}
